/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtraFieldOptionDto
 */
export interface ExtraFieldOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ExtraFieldOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExtraFieldOptionDto
     */
    label: string;
}

/**
 * Check if a given object implements the ExtraFieldOptionDto interface.
 */
export function instanceOfExtraFieldOptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function ExtraFieldOptionDtoFromJSON(json: any): ExtraFieldOptionDto {
    return ExtraFieldOptionDtoFromJSONTyped(json, false);
}

export function ExtraFieldOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtraFieldOptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function ExtraFieldOptionDtoToJSON(value?: ExtraFieldOptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
    };
}

